import { ICompanySettings } from './models';

const companySettings: Array<ICompanySettings> = [];

export default companySettings;
